import React, { useState } from 'react';

/** Client photo with an initials fallback when the image host is unreachable. */
export default function WorkAvatar({ src, name, logo = false }) {
  const [failed, setFailed] = useState(!src);
  const initials = name.split(/\s+/).filter(Boolean).map((w) => w[0]).slice(0, 2).join('').toUpperCase();
  if (failed) {
    return <span className="work-avatar work-avatar--initials" role="img" aria-label={name}>{initials}</span>;
  }
  return <img className={`work-avatar${logo ? ' work-avatar--logo' : ''}`} src={src} alt={name} width="88" height="88" loading="lazy" onError={() => setFailed(true)} />;
}
